const theme = {
  fontFamily: [`"Raleway", "sans-serif"`].join(','),
  white: '#fafafa',
  black: '#242323',
  primary: '#314658',
  secondary: '#d96c06ff',
  accent: '#ea5234',
  background: '#e8e8e8',
}

export default theme
